<script setup lang="ts">
import { defineEmits, defineProps, onMounted, reactive, withDefaults } from "vue"

export interface Props {
  department: any
}
export interface Emits {
  (e: "dataLoaded", data: Array<any>): void
}

const props = withDefaults(defineProps<Props>(), {
  department: null,
})
const emits = defineEmits<Emits>()

const state = reactive<{
  peopleData: Array<any>
  isLoading: boolean
}>({
  peopleData: [],
  isLoading: false,
})

onMounted(async () => {
  if (props.department === undefined) {
    return
  }
  state.isLoading = true
  const peopleData = await fetch(`/api/people?department_tid=${props.department.tid}`).then((res) => res.json())
  state.peopleData = peopleData
  state.isLoading = false
  emits("dataLoaded", state.peopleData)
})
</script>

<template>
  <div class="people-panel">
    <div v-if="state.isLoading === true" class="row">
      <div v-for="(item, index) in 4" :key="index" class="col-12 col-md-3">
        <div class="card card-skeleton d-flex flex-column gap-1">
          <div class="card-img-top skeleton"></div>
          <div class="card-body px-0 py-5 skeleton">
            <span class="hidden">{{ item }}</span>
          </div>
        </div>
        <!-- /.card -->
      </div>
      <!-- /.col-3 -->
    </div>
    <!-- /.row -->
    <div v-if="state.isLoading === false" class="row justify-content-center">
      <div v-for="(item, index) in state.peopleData" :key="index" class="col-12 col-lg-3 col-md-4">
        <div class="card shadow-none bg-transparent text-center">
          <figure class="card-img-top lift">
            <a :href="'/node/' + item.nid" hreflang="en">
              <img class="image-style-people" :src="item.photo" loading="lazy" :alt="item.title" typeof="Image" />
            </a>
          </figure>
          <div class="card-body px-0 py-5">
            <h5 class="mb-1">
              <a :href="'/node/' + item.nid" hreflang="en">{{ item.title }}</a>
            </h5>
            <p class="mb-0">{{ item.position }}</p>
          </div>
        </div>
        <!-- /.card -->
      </div>
      <!-- /.col-3 -->
    </div>
    <!-- /.row -->
  </div>
</template>

<style lang="scss" scoped>
.card-skeleton {
  height: 180px;
  .card-img-top {
    height: 80%;
  }
  .card-body {
    height: 20%;
  }
}
figure img {
  max-width: 300px !important;
}
.image-style-people {
  width: 156px;
  height: 156px;
}
</style>
